import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    class: `pa-0 ${_vm.hideBorderOnCollapse ? 'hiddenBorder mb-0' : 'exp01ff mb-4'}`
  }, [_c(VMenu, {
    staticClass: "menu",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VTextField, _vm._g(_vm._b({
          staticClass: "input-truncate",
          attrs: {
            "value": _vm.displayText,
            "dense": _vm.dense,
            "disabled": _vm.disabled,
            "outlined": "",
            "readonly": "",
            "hide-details": ""
          },
          scopedSlots: _vm._u([{
            key: "prepend-inner",
            fn: function () {
              return [_c(VIcon, {
                staticStyle: {
                  "margin-right": "6px"
                },
                attrs: {
                  "color": _vm.disabled ? null : _vm.color
                }
              }, [_vm._v("fal fa-calendar-alt")])];
            },
            proxy: true
          }, {
            key: "append",
            fn: function () {
              return [_c(VIcon, [_vm._v(_vm._s(_vm.getExpandIcon(attrs['aria-expanded'])))])];
            },
            proxy: true
          }], null, true)
        }, 'v-text-field', attrs, false), on))];
      }
    }])
  }, [_c(VCard, [_c(VList, [_c(VListItem, [_c(VRow, {
    staticClass: "pa-0 cols-2",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_vm.isRange ? _c('ul', {
    staticClass: "quickRangeList"
  }, [_c('li', {
    staticClass: "text-subtitle-2 quickRangeListSectionHeader"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.sectionRangesRelative')) + "\n                ")]), _vm._l(_vm.relativeRangeTextSelection, function (rangeInfo, idx) {
    return _c('li', {
      key: `rangeRelative_${idx}`
    }, [_c(VBtn, {
      attrs: {
        "text": "",
        "small": ""
      },
      on: {
        "click": function ($event) {
          return _vm.handleQuickRangeClick(rangeInfo.momentQuery, false, rangeInfo.count, rangeInfo.text);
        }
      }
    }, [_vm._v("\n                    " + _vm._s(rangeInfo.text) + "\n                  ")])], 1);
  }), _c('li', {
    staticClass: "text-subtitle-2 quickRangeListSectionHeader"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.sectionRangesQuick')) + "\n                ")]), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1d/d', false, null, 'yesterday');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.yesterday')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-2d/d', false, null, 'dayBeforeYesterday');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.dayBeforeYesterday')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-7d/d', false, null, 'thisDayLastWeek');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisDayLastWeek')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1w/w', false, null, 'previousWeek');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousWeek')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1M/M', false, null, 'previousMonth');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousMonth')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1y/y', false, null, 'previousYear');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousYear')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/d', false, null, 'today');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.today')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/d', true, null, 'todaySoFar');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.todaySoFar')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/w', false, null, 'thisWeek');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisWeek')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/w', true, null, 'thisWeekSoFar');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisWeekSoFar')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/M', false, null, 'thisMonth');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisMonth')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/M', true, null, 'thisMonthSoFar');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisMonthSoFar')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/y', false, null, 'thisYear');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisYear')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/y', true, null, 'thisYearSoFar');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisYearSoFar')) + "\n                  ")])], 1)], 2) : _vm._e(), !_vm.isRange ? _c('ul', {
    staticClass: "quickRangeList"
  }, [_c('li', {
    staticClass: "text-subtitle-2 quickRangeListSectionHeader"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.sectionRangesRelative')) + "\n                ")]), _vm._l(_vm.relativeSingleTextSelection, function (rangeInfo, idx) {
    return _c('li', {
      key: `rangeSingle_${idx}`
    }, [_c(VBtn, {
      attrs: {
        "text": "",
        "small": ""
      },
      on: {
        "click": function ($event) {
          return _vm.handleQuickRangeClick(rangeInfo.momentQuery, false, rangeInfo.count, rangeInfo.text);
        }
      }
    }, [_vm._v("\n                    " + _vm._s(rangeInfo.text) + "\n                  ")])], 1);
  })], 2) : _vm._e()])], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };